// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dd53e008","622":"3e3ba703","977":"50cfffe7"}[chunkId] + ".chunk.js";
};